//GLOBAL VARIABLE
//USE THIS INSTAED OF CREATING AGAIN AND AGAIN :)
var WINDOW_WIDTH = $(window).width();


$(function(){

  announcementBarSlider();
  productGridSlider();
  productGridSliderUpDown(); 
  collectionListSlider();
  categoryListSlider();
  homeReviewsSlider();
  productGridSliderTwo();
  productGridSliderThree();
  VIPCampaignSlider();
  verticalNavigation();
  upsellProductsSlider();
  lookbookBannerSlider();

  
  /* footer mobile accordian */
  $(document).on('click','.link_list_box h2', function(e){
    e.preventDefault();
    if(WINDOW_WIDTH < 1400 ){
      if($(this).parent().hasClass('active')){
          $(this).closest('.link_list_box').find('.footer-block__details-content').slideUp(500);
          $(this).parent().removeClass('active');
      }else{
          $('.link_list_box').removeClass('active');
          $(this).parent().addClass('active');
          $('.footer-block__details-content').slideUp(500);
          $(this).closest('.link_list_box').find('.footer-block__details-content').slideDown(500);
      }
    }
  });
  /* END - footer mobile accordian */

  /* recently view mobile grid hide */
  if(WINDOW_WIDTH < 1200){
    if($('body').hasClass('template--product')){
      $('.template--product .recently-viewed-grid li').each(function(index){
        // console.log('index',index);
        if(index > 3){
          $(this).addClass('hide-mbl');
        }
      });
    }
  }
  /* END recently view mobile grid hide */

  /* Upseel events */
  function handleQuickDrawerClick(element) {

    let quickAddAccordion = $(element).closest('.quick-add-accordion');
    let dataTitle = $(element).attr('data-title');
  
    quickAddAccordion.siblings().each(function() {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active');
      }
    });
  
    if (dataTitle !== undefined && dataTitle !== null) {
      $('.upsell-drawer-main .desc-drawer-head .tab-li [title="' + dataTitle + '"]').click();
    } else {
      $('.upsell-drawer-main .desc-drawer-head .tab-li a:first').click();
    }
  }
  
  function closeUpsellDrawer() {
    $('.upsell-drawer-main').removeClass('active');
    $('.quick-drawer-content .quick-add-accordion .accordion-box').removeClass('active');
  }
  
  $(document).on('click', '.quick-drawer-content .quick-add-accordion .accordion-box', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    handleQuickDrawerClick(this);
  });
  
  $(document).on('click', '.upsell-close-btn', closeUpsellDrawer);
  

  /* drawer open close code*/
  $(document).on('click','.product__info-container .styled-product-box', function(e){
    e.preventDefault();
    if(WINDOW_WIDTH < 1200){
       var link_redirect = $(this).attr('href');
       window.location.href = link_redirect;
    }else{
      $("body").addClass("pro-quick-open");
      $(this).closest('.col').find('.quick-drawer-main').addClass('active'); 
      $(this).closest('.lookbook_grid').find('.quick-drawer-main').addClass('active'); 
    }

    handleQuickDrawerClick($(this).closest('.quick-drawer-main').find('.quick-add-accordion .accordion-box'));
  });
  $(document).on('click','.pro-quick-close', function(e){
    $(this).closest('.quick-drawer-main').removeClass('active');
    document.body.classList.remove('overflow-hidden');
    document.querySelector('#MainContent').classList.remove('pe-none');
  });
  /* END drawer open close code*/
  
  /*Product Star review */
  //var prodStar = setInterval(setProductStarRating, 1000);
  function setProductStarRating() {
    if($('.template--product .yotpo.bottomLine').length > 0){
      $('.template--product .yotpo.bottomLine').each(function(){
        var pdID = $(this).attr('data-product-id');
        var avgRatingText = $(this).text().trim();
        console.log('pdID--',pdID, 'avgRatingText',avgRatingText);
      });
      clearInterval(prodStar);
    }else{
      clearInterval(prodStar);
    }
  }
  /*END - Product Star review */
  

  /* Product description drawer */
  $(document).on('click','.product__info-container .pro-description-btn', function(e){
    e.preventDefault();
    $("body").addClass("pro-description-open");
  });
  $(document).on('click','.description-drawer-main .pro-description-close', function(e){
    e.preventDefault();
    $("body").removeClass("pro-description-open");
  });
  /*END - Product description drawer */

  /* Product quick add drawer */
  $(document).on('click','.complete-look .looks-pro-list .col .card-wrapper', function(e){
    e.preventDefault();
    $("body").addClass("pro-quick-open");
    $(this).closest('.col').find('.pro-drawer-main').addClass('active');
  });
  $(document).on('click','.quick-drawer-main .pro-quick-close', function(e){
    e.preventDefault();
    $("body").removeClass("pro-quick-open");
    document.body.classList.remove('overflow-hidden');
    document.querySelector('#MainContent').classList.remove('pe-none');
  });
  $('body').on("click", function(e) { 
    if ($(e.target).is('.quick-drawer-main.active') === true && $(e.target).is('.quick-drawer-row') === false) {
      $('body').removeClass('pro-quick-open');
      document.body.classList.remove('overflow-hidden');
      document.querySelector('#MainContent').classList.remove('pe-none');
      $('.quick-drawer-main').removeClass('active');
    }
  });
  /*END - Product quick add drawer */

  /* Quick add accordion */
  $(document).on('click','#pro-accordion .accordion-box .title', function(){
    if($(this).closest('.accordion-box').hasClass('active')){
      $(this).closest('.accordion-box').find('.panel').slideUp(300);
      $(this).closest('.accordion-box').removeClass('active');
    }else{
      $(this).closest('#pro-accordion').find('.panel').slideUp(300);
      $(this).closest('#pro-accordion').find('.accordion-box.active').removeClass('active');
      $(this).closest('.accordion-box').find('.panel').slideToggle(300);
      $(this).closest('.accordion-box').addClass('active');
    }
  });
  /*END - Quick add accordion */

  /* Quick add accordion tab */

  if($('.template--collection').length || $('.template--search').length){
    $(document).on('click','#pro-accordion .accordion-box', function(){
      console.log("asd")
      $('.pro-drawer-inner').closest('.description-drawer-main').addClass('active');
      var dataTitle = $(this).attr('data-title');
      //console.log('dataTitle',dataTitle);
      if (dataTitle != undefined || dataTitle != null){
        $('.desc-drawer-head .tab-li [title="'+dataTitle+'"]').click();
      }else{ 
        $('.desc-drawer-head .tab-li a:first').click();
      }
    });
  }
  /*END - Quick add accordion tab */

  
  /*size guid link click to scroll size guid tab*/
  if($('.template--product').length || $('.template--collection').length || $('.template--search').length){
    $(document).on('click','variant-radios .size-guide-btn', function(e){
      e.preventDefault();
      //var sizeGuidTabPos = $('#main_prod_section .product__info-wrapper:eq(0)').outerHeight() - 120;
      $('.product__info-wrapper .pro-accordion-item .accordion-box[data-title="Size"] a').click();
    });
  }
  /*end*/

  
  /* Drawer tab */
  $(document).on('click','.desc-drawer-head .tab-li a', function(e){
    e.preventDefault();
    var title = $(this).attr('title');
    $(this).closest('.desc-drawer-tab').find('.tab-li a.active').removeClass('active');
    $(this).closest('.desc-drawer-tab').find('.tabcontent.active').removeClass('active');
    $(this).closest('.desc-drawer-tab').find('.tab-li a[title="'+title+'"]').addClass('active');
    $(this).closest('.desc-drawer-tab').find('.tabcontent[data-title="'+title+'"]').addClass('active');

    $(document).on('click','.description-drawer-main [data-inch], .upsell-drawer-main [data-inch]', function(e){
      e.preventDefault();
      $('.description-drawer-main .tab-info [data-size-links] a, .upsell-drawer-main .tab-info [data-size-links] a').removeClass('active');
      $(this).addClass('active');
      $('.description-drawer-main .tab-info .size-table-box, .upsell-drawer-main .tab-info .size-table-box').addClass('hidden');
      $('.description-drawer-main .tab-info .size-table-box[data-inch-size], .upsell-drawer-main .tab-info .size-table-box[data-inch-size]').removeClass('hidden');
    });
    $(document).on('click','.description-drawer-main [data-cm], .upsell-drawer-main [data-cm]', function(e){
      e.preventDefault();
      $('.description-drawer-main .tab-info [data-size-links] a, .upsell-drawer-main .tab-info [data-size-links] a').removeClass('active');
      $(this).addClass('active');
      $('.description-drawer-main .tab-info .size-table-box, .upsell-drawer-main .tab-info .size-table-box').addClass('hidden');
      $('.description-drawer-main .tab-info .size-table-box[data-cm-size], .upsell-drawer-main .tab-info .size-table-box[data-cm-size]').removeClass('hidden');
    });
  });
  /* End Drawer tab */

  /* Whishlist */
  $(document).on('click','.no-wish', function(){
     var _this = $(this);
     var prod_id = _this.closest('product-form').attr('data-id');
    
     if(_this.find('.sW-BB-deactive').length){
       _this.closest('.product__info-container').find('.variant-box-wrap[data-id="'+prod_id+'"] .add-cart-text').addClass('hidden'); 
       if(_this.find('.sW-BB-deactive').hasClass('swym-added')){
         _this.closest('.product__info-container').find('.variant-box-wrap[data-id="'+prod_id+'"] .add-wishlist-text.remove-wish').removeClass('hidden');   
       }else{
         _this.closest('.product__info-container').find('.variant-box-wrap[data-id="'+prod_id+'"] .add-wishlist-text:not(.remove-wish)').removeClass('hidden'); 
       }
     }
    
  });
  /* END Whishlist */

  /* addtocart disable */
  $(document).on('click','.no-click-product',function(e){
    var _this = $(this);
    var prod_id = _this.closest('product-form').attr('data-id');
    if(!_this.hasClass('active')){
      _this.closest('.product__info-container').find('.variant-box-wrap[data-id="'+prod_id+'"] .add-cart-text').removeClass('hidden');
      _this.closest('.product__info-container').find('.variant-box-wrap[data-id="'+prod_id+'"] .add-wishlist-text').addClass('hidden');
    }
  });

  /* END addtocart disable */


  /* sticky drawer open-close */
  $(document).on('click','.select-col .select .styledSelect',function(e){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).closest('.cart-sticky-top').find('.styledSelect.active').removeClass('active');
      $(this).addClass('active');    
    }
  });
  /* END sticky drawer open-close */

  /* main product sticky add to cart */
  $(document).on('click','.add-cart-sticky.main-sticky-product .cart-sticky-top .select-col:eq(1) .options li',function(e){
     if(!$(this).hasClass('no-click')){
         var _this = $(this);
         var v_id = _this.closest('form').attr('data-id');
         var get_size = _this.find('span').text();
         var index_no = _this.attr('data-index');
         var variant_id = $('.variant-box-wrap[data-id="'+v_id+'"] .variant-box-size .variant-box-list label[data-index="'+index_no+'"]').attr('data-vid');
         $('.variant-box-wrap[data-id="'+v_id+'"] .variant-box-size .variant-box-list label[data-index="'+index_no+'"]').click();
         _this.closest('.add-cart-sticky.main-sticky-product').find('[data-wishlist-btn] .swym-add-to-wishlist-view-product').attr('data-variant-id',variant_id);
         _this.closest('.select').find('.styledSelect').text(get_size);
         window.triggerSwymVariantEvent(variant_id);
         //window._swat.initializeActionButtons(".add-cart-sticky.main-sticky-product [data-wishlist-btn]");
         _this.closest('.add-cart-sticky.main-sticky-product').find('[data-wishlist-btn] .swym-button').removeClass('sW-BB-deactive');
         _this.closest('.select').find('.styledSelect').removeClass('active');

        _this.closest('.add-cart-sticky.main-sticky-product').find('[data-wishlist-btn] .swym-add-to-wishlist-view-product').prop('disabled', false);
     }
  });
  $(document).on('click','.add-cart-sticky.main-sticky-product [data-sticky-add-cart]',function(e){
    e.preventDefault();
    if($(this).hasClass('no_size')){
      return;
    }
    var v_id = $(this).closest('form').attr('data-id');
    $('.product__info-container').find('product-form[data-id="'+v_id+'"] form[data-type="add-to-cart-form"] button[type="submit"]').click();
    $(this).addClass('loading');
    $(this).children('.loading-overlay__spinner').removeClass('hidden');
  });
  /* END main product sticky add to cart */

  /* quick drawer product sticky add to cart */
  $(document).on('click','.add-cart-sticky.quick-sticky-cart',function(e){
    $(this).find('.cart-sticky-top .select-col.size-sticky .options li').on('click',function(){
      if(!$(this).hasClass('no-click')){
         var _this = $(this);
         var v_id = _this.closest('form').attr('data-id');
         var get_size = _this.find('span').text();
         var index_no = _this.attr('data-index');
         var variant_id = $('.variant-box-wrap[data-id="'+v_id+'"] .variant-box-size .variant-box-list label[data-index="'+index_no+'"]').attr('data-vid');
         $('.variant-box-wrap[data-id="'+v_id+'"] .variant-box-size .variant-box-list label[data-index="'+index_no+'"]').click();
         _this.closest('.select').find('.styledSelect').text(get_size);
         _this.closest('.add-cart-sticky.quick-sticky-cart').find('[data-quick-sticky-cart]').removeClass('no_size');
         _this.closest('.add-cart-sticky.quick-sticky-cart').find('[data-quick-sticky-cart] .no_size_display').remove();
         _this.closest('.add-cart-sticky.quick-sticky-cart').find('[data-wishlist-btn] .swym-add-to-wishlist-view-product').attr('data-variant-id',variant_id);
          window.triggerSwymVariantEvent(variant_id);
          //window._swat.initializeActionButtons('.add-cart-sticky.quick-sticky-cart [data-wishlist-btn]');
        _this.closest('.add-cart-sticky.quick-sticky-cart').find('[data-wishlist-btn] .swym-button').removeClass('sW-BB-deactive');
        _this.closest('.select').find('.styledSelect').removeClass('active');

        _this.closest('.add-cart-sticky.quick-sticky-cart').find('[data-wishlist-btn] .swym-add-to-wishlist-view-product').prop('disabled', false);
     }
    });
  });
  $(document).on('click','.add-cart-sticky.quick-sticky-cart [data-quick-sticky-cart]',function(e){
    e.preventDefault();
    if($(this).hasClass('no_size')){
      return;
    }
    var v_id = $(this).closest('form').attr('data-id');
    $(this).closest('.quick-drawer-main').find('.product__info-container product-form[data-id="'+v_id+'"] form[data-type="add-to-cart-form"] button[type="submit"]').click();
    $(this).addClass('loading');
    $(this).children('.loading-overlay__spinner').removeClass('hidden');
  });
   /* END quick drawer product sticky add to cart */


  /* show Color */
  if($('body').hasClass('template--product')){
    let imageUrl = $('section[data-image-url-js]').attr('data-image-url-js');
    let colors = {
      'argent': '#8a8f91',
      'beige': '#d6be9f',
      'blanc': 'white',
      'bleu': '#0268db',
      'bronze': '#69441c',
      'brun': '#381e08',
      'gris': '#b8b7b6',
      'jaune': '#f7da57',
      'mauve': '#6b2fd4',
      'noir': 'black',
      'or': '#b57f09',
      'orange': '#e8761e',
      'rose': 'pink',
      'rouge': '#c90226',
      'vert': '#018c37',
    };
    if(json_obj.length > 0){
      for(var i=0;i<json_obj.length;i++){
        console.log(json_obj[i]);
        let colorGroup = json_obj[i].color_group;
        let colorName = json_obj[i].color_name;
        //setup translation color
        if(document.body.dataset.locale == "en"){
          let foundColor = product_tags_translations.find((element) => element.includes(`${colorName}:`));
          if(foundColor){
            colorName = foundColor.split(':')[1];
          }
        }
        //end setup translation color
        let colorHex = json_obj[i].color_hex;
        let colorNameImg = handleizeString(colorGroup);
        let colorImgPng = imageUrl.replace("DO-NOT-DELETE",colorNameImg).replace("?v=1669806096","?width=64");
        let colorSwatch = colorHex != '' ? '#'+colorHex : colors[colorGroup.toLowerCase()];
        //console.log(colorImgPng);
        if(json_obj[i].handle == json_obj[i].main_handle){
          if(json_obj[i].product_status == 'true'){
            var html = '<a class="color-box active" href="'+json_obj[i].url+'" title="" sold-var="'+json_obj[i].size_variants+'"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span><div class="tooltip-text">'+colorName+'</div></a>';
            var html2 = '<li><a href="'+json_obj[i].url+'" title="" class="select-option active" sold-var="'+json_obj[i].size_variants+'"><span class="color-wrap"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span></span></a></li>';  
          }else{
            var html = '<a class="color-box active sold-variant" href="'+json_obj[i].url+'" title="" sold-var="'+json_obj[i].size_variants+'"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span></a>';
            var html2 = '<li><a href="'+json_obj[i].url+'" title="" class="select-option active sold-variant" sold-var="'+json_obj[i].size_variants+'"><span class="color-wrap"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span></span></a></li>';
          }
        }else{
          if(json_obj[i].product_status == 'true'){
            var html = '<a class="color-box" href="'+json_obj[i].url+'" title="" sold-var="'+json_obj[i].size_variants+'"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span><div class="tooltip-text">'+colorName+'</div></a>';
            var html2 = '<li><a href="'+json_obj[i].url+'" title="" class="select-option" sold-var="'+json_obj[i].size_variants+'"><span class="color-wrap"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span></span></a></li>';  
          }else{
            var html = '<a class="color-box sold-variant" href="'+json_obj[i].url+'" title="" sold-var="'+json_obj[i].size_variants+'"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span><div class="tooltip-text">'+colorName+'</div></a>';
            var html2 = '<li><a href="'+json_obj[i].url+'" title="" class="select-option" sold-var="'+json_obj[i].size_variants+'"><span class="color-wrap sold-variant"><span style="background-color: '+colorSwatch+'; background-image: url('+colorImgPng+');"></span></span></a></li>';
          }
        }
        if(json_obj[i].handle != ''){
          $('.variant-box-color .product-form__input .variant-box-list').append(html);
          // $('.cart-sticky-top .select-col:eq(0) ul.options').append(html2);
          $('.main-sticky-product .cart-sticky-top .select-col:eq(0) ul.options').append(html2);
          if($('.variant-box-color .variant-box-list a').length > 0){
            $('.variant-box-color').removeClass('hidden');
          }
          if($('.add-cart-sticky.main-sticky-product .cart-sticky-top .select-col:eq(0) .options li').length > 1){
            $('.add-cart-sticky.main-sticky-product .cart-sticky-top .select-col:eq(0)').removeClass('hidden');
          }  
        }
      }
    }
  }
  /* END show Color */

  /* complete the look section */
  if($('.main-col.main-img').length > 0 || $('.complete-look .main-col .looks-pro-list .col').length > 0){
    $('.complete-look').removeClass('hidden');
  }
  /* END complete the look section */

  
  /* this js will apply when :has css selector will not applied to old browser. */
  if($("#MainContent .banner-pro-products-wrapper .data-item").length){
    $('#MainContent .collection-hero__inner').addClass('new-font-size');
  }
  /*END*/

  
  // cart-drawer -- cart-note
  $(document).on("click","[cart-note-toggle]",function(){
    $(this).toggleClass("active");
    $("#cart_note-main cart-note.cart__note").slideToggle();
  });
  // cart-drawer -- cart-note


  // Tom js started
  $('#pro-accordion .accordion-box').click(function(){
    console.log("asd")
    $('.pro-drawer-inner').closest('.description-drawer-main').addClass('active');
    var dataTitle = $(this).attr('data-title');
    //console.log('dataTitle',dataTitle);
    if (dataTitle != undefined || dataTitle != null){
      $('.desc-drawer-head .tab-li [title="'+dataTitle+'"]').click();
    }else{ 
      $('.desc-drawer-head .tab-li a:first').click();
    }
  });

   $('body').on("click", function(e) { 
    if ($(e.target).is('.description-drawer-main.active') === true && $(e.target).is('.pro-drawer-inner') === false) { 
      $('body').removeClass('pro-description-open');
      $('.description-drawer-main').removeClass('active');
    }
  });
  // Tom js ended


  console.log('custom js loaded');


  // Upsell PDP events
  
});


$(window).on('load',function() {
  
  if($('body').hasClass('template--product')){
    console.log(window.scrollY,$('header:eq(0)').outerHeight());
    if(window.scrollY == 0){
      if(WINDOW_WIDTH < 576){
        setTimeout(function(){
            var header_height = $('header:eq(0)').outerHeight();
            $("html, body").animate({ scrollTop: header_height }, "slow");
        },1000);  
      }  
    }
  }

  
  if($('form[id="email_signup"]').length > 0){
    let crLocation = window.location.href;
    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true,
      success_message: "Merci pour votre inscription!",
      extra_properties: {
        $source: crLocation,
        $method_type: "Klaviyo Form",
        $method_id: 'embed'
      },
      success: function ($form) {
        var email = $form.querySelector('[name="email"]').value;
      }
    });  
  }
  
});



window.addEventListener('load', function() {
  
  screenResizeObsever();

  //AOS animation start
    AOS.init({duration: 1200});
  //AOS end
  
});


function productGridSlider(windowWidth = WINDOW_WIDTH) {
  const productGridSliderContainer = $('.product-grid-slider') || null;
  
  if(productGridSliderContainer != null && productGridSliderContainer.length > 0 && windowWidth > 749){
    let slideToScrollPos;
    windowWidth >= 990 ? slideToScrollPos = 4 : slideToScrollPos = 3;
    productGridSliderPagination(productGridSliderContainer,slideToScrollPos,windowWidth = WINDOW_WIDTH);
    
    $(productGridSliderContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });

    if($('.product-grid-slider.recently-viewed-grid').length > 0){
      if($('.product-grid-slider.recently-viewed-grid li.grid_item').length < 5){
        $('.recently-viewed-wrapper .slick-dots').addClass('hidden');
      }
    }
    
  }else{
    if($(productGridSliderContainer).hasClass('slick-initialized')){
      $(productGridSliderContainer).slick('unslick');  
    }
    $('.featured-collection .pagingInfo').text(''); // remove pagedots text
  }
}

function productGridSliderPagination(sliderContainer,slideScrollPos,windowWidth) {
  for(let i=0; i<sliderContainer.length; i++){
    
    let currentSection = sliderContainer[i];
    //console.log('currentSection', currentSection);
    
    let sectionTotalSLide = Number($(currentSection).closest('section').find('[data-total-slide]').eq(0).attr('data-total-slide'));
    if($(currentSection).hasClass("recently-viewed-grid")){
      // console.log('recently view section');
      sectionTotalSLide = Number($(currentSection).find('.grid_item').eq(0).attr('data-total-slide'));
    }
    // console.log(sectionTotalSLide);
    
    $(currentSection).on('init reInit afterChange',function(event,slick,currentSlide,nextSlide) {
      if(!currentSlide) currentSlide = 0;
      let currentIndex = currentSlide + slideScrollPos;
      //console.log('currentIndex-->',currentIndex, 'sectionTotalSLide--',sectionTotalSLide);

      if($(currentSection).hasClass("recently-viewed-grid")){
          if(windowWidth >= 990 && sectionTotalSLide > 4){
            $(currentSection).siblings('.pagingInfo').text(Math.ceil(currentIndex/slideScrollPos) + ' / ' + Math.ceil(sectionTotalSLide/slideScrollPos));
          }else if(windowWidth < 990 && sectionTotalSLide > 3){
           $(currentSection).siblings('.pagingInfo').text(Math.ceil(currentIndex/slideScrollPos) + ' / ' + Math.ceil(sectionTotalSLide/slideScrollPos)); 
          }else{
            $(currentSection).siblings('.pagingInfo').text('');
            $(currentSection).find('.slick-dots').hide();
          }
        } else{
          if(windowWidth >= 990 && sectionTotalSLide > 4){
            $(currentSection).closest('section').find('.pagingInfo').text(Math.ceil(currentIndex/slideScrollPos) + ' / ' + Math.ceil(sectionTotalSLide/slideScrollPos));
          }else if(windowWidth < 990 && sectionTotalSLide > 3){
           $(currentSection).closest('section').find('.pagingInfo').text(Math.ceil(currentIndex/slideScrollPos) + ' / ' + Math.ceil(sectionTotalSLide/slideScrollPos)); 
          }else{
            $(currentSection).closest('section').find('.pagingInfo').text('');
            $(currentSection).closest('section').find('.slick-dots').hide();
          }
        }

    });
  }
}

function productGridSliderUpDown() {
  $(document).on("click", ".featured-collection .show-more-btn", function (e) {
    e.preventDefault();
    if ($(this).hasClass("open")) {
      $(this).find('span').text("Voir plus");
      var elHeight =  $(this).closest(".featured-collection").offset().top - 100;
      $("html, body").animate({ scrollTop: elHeight},600);
     $(this).closest(".featured-collection").find(".product-grid-slider .hide-mbl").removeAttr('style');
    } else {
      $(this).find('span').text("Voir moins");
      $(this).closest(".featured-collection").find(".product-grid-slider .hide-mbl").slideDown(350);
    }
    $(this).toggleClass("open");
  });
}

function collectionListSlider(windowWidth = WINDOW_WIDTH) {
  const collectionListContainer = $('.collection-list-slider') || null;
  if(collectionListContainer != null && collectionListContainer.length > 0 && windowWidth > 989){
    $(collectionListContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      draggable: true,
      swipe: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
            arrows: true,
            draggable: true,
            swipe: true,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            arrows: true,
            draggable: true,
            swipe: true,
          }
        }
      ]
    });
  } else {
    if($(collectionListContainer).hasClass('slick-initialized')){
      $(collectionListContainer).slick('unslick');  
    }
  }
}

function subCatsSlider(windowWidth = WINDOW_WIDTH) {
  const subCatsContainer = $('.banner-pro-products-wrapper .coll-data') || null;
  if(subCatsContainer != null && subCatsContainer.length > 0 && windowWidth > 1200){
    $(subCatsContainer).not('.slick-initialized').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      draggable: true,
      swipe: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: "unslick"
        }
      ]
    });
  } else {
    if($(subCatsContainer).hasClass('slick-initialized')){
      $(subCatsContainer).slick('unslick');  
    }
  }
}

function categoryListSlider(windowWidth = WINDOW_WIDTH) {
  const categoryListContainer = $('.category-list-slider') || null;
  if(categoryListContainer != null && categoryListContainer.length > 0 && windowWidth > 989){
    $(categoryListContainer).not('.slick-initialized').slick({
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      dots: false,
      arrows: false,
      responsive: [,
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }
      ]
    });
  }else{
    if($(categoryListContainer).hasClass('slick-initialized')){
      $(categoryListContainer).slick('unslick');  
    }
  }
}

function homeReviewsSlider(windowWidth = WINDOW_WIDTH) {
  const homeReviewsContainer = $('.home-reviews-slider') || null;
  if(homeReviewsContainer != null && homeReviewsContainer.length > 0 && windowWidth > 989){
    $(homeReviewsContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }else{
    if($(homeReviewsContainer).hasClass('slick-initialized')){
      $(homeReviewsContainer).slick('unslick');  
    }
  }
}

function productGridSliderTwo(windowWidth = WINDOW_WIDTH) {
  const productGridSliderTwoContainer = $('.product-grid-slider-two') || null;
  if(productGridSliderTwoContainer != null && productGridSliderTwoContainer.length > 0){
    let slideToScrollPos;
    windowWidth >= 990 ? slideToScrollPos = 4 : slideToScrollPos = 3;
    //For paginate function
    productGridSliderPagination(productGridSliderTwoContainer,slideToScrollPos,windowWidth = WINDOW_WIDTH);
    //END
    $(productGridSliderTwoContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 750,
          settings: {
            centerMode: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 641,
          settings: {
            centerMode: true,
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

function productGridSliderThree() {
  const productGridSliderThreeContainer = $('.product-grid-slider-three') || null;
  if(productGridSliderThreeContainer != null && productGridSliderThreeContainer.length > 0){
    $(productGridSliderThreeContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            centerMode: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 641,
          settings: {
            centerMode: true,
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

function verticalNavigation() {
  $('[data-close-menu] > svg').on('click',function(e){
     e.preventDefault();
     $('.vertical-header [data-menu--toggle][aria-expanded="true"]').trigger('click'); 
  });
  $('.vertical-header [data-drawer-icon] .dk--serch--open').on('click',function(e){
     e.preventDefault();
     $(this).closest('[data-menu-drawer]').find('.menu-drawer-search').addClass('active-search');
  });
  $('.vertical-header .header__icons .dk--serch--open').on('click',function(e){
     e.preventDefault();
     $('.vertical-header [data-menu--toggle][aria-expanded="false"]').trigger('click'); 
     $('.vertical-header [data-menu-drawer] .menu-drawer-search').addClass('active-search');
  });
  $('.vertical-header [data-menu-drawer] .menu-drawer-search .search-back').on('click',function(e){
     e.preventDefault();
     e.stopPropagation();
     $(this).parent('.menu-drawer-search').removeClass('active-search');
  });

  $('body').on("click", function(e) {
    if ($(e.target).is('body.vertical_drawer_open') === true && $(e.target).is('[data-menu-drawer]') === false) {
      $('.vertical-header [data-menu--toggle][aria-expanded="true"]').trigger('click'); 
    }
  });

  $(window).scroll(debounce(function(event) {
    const scrollTop = $(this).scrollTop();
    if($('body.template--index').length && $('[data-navigation-color="transparent"]').length || $('body.transparent-header-body').length && $('[data-navigation-color="transparent"]').length){
      scrollTop > 30 ? $('.vertical-header').addClass('light-vertical-header') : $('.vertical-header').removeClass('light-vertical-header'); 
    }
  },50));
  
}

function VIPCampaignSlider() {
  const campaignGridSliderContainer = $('.campaign-grid-slider') || null;
  
  if(campaignGridSliderContainer != null && campaignGridSliderContainer.length > 0){
    $(campaignGridSliderContainer).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            centerMode: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 641,
          settings: {
            centerMode: true,
            slidesToShow: 1
          }
        }
      ]
    });
  }
}

function upsellProductsSlider(windowWidth = WINDOW_WIDTH) {
  if(windowWidth < 750) return;
  const carousel = document.querySelector("[data-upsell-slider]");
  if(!carousel) return;
  const carouselSlide = carousel.querySelectorAll("[data-slide]");
  const arrowIcons = document.querySelectorAll(".slider-wrap [data-navigation]");

  if(carouselSlide.length < 4 || !arrowIcons.length) return;
  
  const firstImg = carouselSlide[0];
  let prevScrollLeft, positionDiff;

  function navArrowsUpdate(){
    // disabled and enabled prev/next icon according to carousel scroll left value
    let scrollWidth = carousel.scrollWidth - carousel.clientWidth; // getting max scrollable width
    //console.log('scrollWidth-->',scrollWidth, 'scrollLeft-->',carousel.scrollLeft);
    carousel.scrollLeft === 0 ? arrowIcons[0].classList.add("disabled") : arrowIcons[0].classList.remove("disabled");
    carousel.scrollLeft === scrollWidth ? arrowIcons[1].classList.add("disabled") : arrowIcons[1].classList.remove("disabled");
    setTimeout(() => carousel.classList.remove('is-scrolling'),175);
  }

  arrowIcons.forEach(icon => {
    icon.addEventListener("click", (e) => {
      e.preventDefault();
      carousel.classList.add('is-scrolling');
      let firstImgWidth = firstImg.clientWidth; // getting first img width
      // if clicked icon is left, reduce width value from the carousel scroll left else add to it
      carousel.scrollLeft += icon.id == "left" ? -firstImgWidth : firstImgWidth;
      setTimeout(() => navArrowsUpdate(), 275);
    });
  });
  
}


function lookbookBannerSlider() {
  const lookbookSliderContainer = $('.lookbook-banner-slider [data-banner-slider]') || null;
  
  if(lookbookSliderContainer != null && lookbookSliderContainer.length > 0){
    let isAutoplay = lookbookSliderContainer.attr('data-autoplay'),
        slideSpeed = lookbookSliderContainer.attr('data-speed');
    if(isAutoplay == 'true' || isAutoplay == true){
      isAutoplay = true;
      slideSpeed = Number(slideSpeed*1000);
    }else{
      isAutoplay = false;
      slideSpeed = 0;
    }
    $(lookbookSliderContainer).not('.slick-initialized').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: isAutoplay,
      autoplaySpeed: slideSpeed,
      dots: true,
      arrows: false
    });
  }
}

function completeLookSlider(windowWidth = WINDOW_WIDTH) {
  const completeLookSliderContainer = $('.complete-look-slider') || null;
  
  if(completeLookSliderContainer != null && completeLookSliderContainer.length > 0){
    let slideToScrollPos;
    windowWidth >= 990 ? slideToScrollPos = 4 : slideToScrollPos = 3;
   // productGridSliderPagination(completeLookSliderContainer,slideToScrollPos,windowWidth = WINDOW_WIDTH);
    
    $(completeLookSliderContainer).not('.slick-initialized').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            swipe: false
          }
        }
      ]
    });

  }else{
    if($(completeLookSliderContainer).hasClass('slick-initialized')){
      $(completeLookSliderContainer).slick('unslick');  
    }
    $('.featured-collection .pagingInfo').text(''); // remove pagedots text
  }
}


function announcementBarSlider(){
  $("[data-announcement-bar-slider]").not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    autoplay:true
    // autoplaySpeed: 2000
  });
}

// Au chargement de la page
$(document).ready(function() {
  announcementBarSlider();
});

// Quand Shopify (Online Store 2.0) recharge une section en édition ou en AJAX
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === 'announcement-bar') {
    announcementBarSlider();
  }
});


function handleizeString(str) {
 return str.toLowerCase().replace(/[-!"#$â‚¹%&'* ,./:;<=>?@[\\\]_`{|}~]+/g, "-").replace(/Ã¤/g, "a").replace(/Ã¶/g, "o").replace(/Ã¼/g, "u").replace(/ÃŸ/g, "ss").replace(/[()]+/g, "").replace(/^-+|-+$/g, ""); 
}

function screenResizeObsever() {
  const productGridSliderContainer = document.querySelector('.product-grid-slider') || null;
  const categoryListContainer = document.querySelector('.category-list-slider') || null;
  const collectionListContainer = document.querySelector('.collection-list-slider') || null;
  const reviewContainer = document.querySelector('.home-reviews-slider') || null;
  var ro = new ResizeObserver(debounce((entries) => {
    let windowWidth = document.body.getBoundingClientRect().width;
    if(productGridSliderContainer){
      productGridSlider(windowWidth);
    }
    if(categoryListContainer){
      categoryListSlider(windowWidth);
    }
    if(collectionListContainer){
      collectionListSlider(windowWidth);
    }
    if(reviewContainer){
      homeReviewsSlider(windowWidth);
    }
  },225));
  
  // Observe one or multiple elements
  if(productGridSliderContainer){
     ro.observe(productGridSliderContainer);
  }
  if(categoryListContainer){
    ro.observe(categoryListContainer);
  }
  if(collectionListContainer){
    ro.observe(collectionListContainer);
  }
  if(reviewContainer){
    ro.observe(reviewContainer);
  }
}



if (WINDOW_WIDTH < 750 ) {
  $(window).on('load resize',function(){
    var _height = $('.complete-look-slider .main-img').height();
    if( _height > 0 && $('.complete-look-slider .main-img').length > 0 ){
      var _top = 'calc(('+_height+'px))';
      $('.complete-look-slider').find('.slick-arrow').css('top',_top);
      $('.complete-look-slider').find('.slick-dots').css('top',_top);
      $('.complete-look-slider').find('.pagingInfo').css('top',_top);
    }else{
      $('.complete-look-slider').find('.slick-arrow').css('top','');
      $('.complete-look-slider').find('.slick-dots').css('top','');
      $('.complete-look-slider').find('.pagingInfo').css('top','');
    }
  })
}


// This will only render in the theme editor
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
     AOS.init({duration: 1200});
     var productGridSliderEditor = event.target.closest('.featured-collection') || null;
      if(productGridSliderEditor){
        productGridSlider();
      }
     var collectionListSliderEditor = event.target.closest('.section-collection-list') || null;
      if(collectionListSliderEditor){
        collectionListSlider();
      }
      var categoryListSliderEditor = event.target.closest('.category-list') || null;
      if(categoryListSliderEditor){
        categoryListSlider();
      }
      var productGridSliderTwoEditor = event.target.closest('.featured-collection-two') || null;
      if(productGridSliderTwoEditor){
        productGridSliderTwo();
      }
      var productGridSliderThreeEditor = event.target.closest('.featured-collection-three') || null;
      if(productGridSliderThreeEditor){
        productGridSliderThree();
      }
      var homeReviewsSliderEditor = event.target.closest('.home-reviews') || null;
      if(homeReviewsSliderEditor){
        homeReviewsSlider();
      }
      var verticalNav = event.target.closest('.section-header') || null;
      if(verticalNav){
        verticalNavigation();
      }
      var lookbookBannerSliderEditor = event.target.closest('.lookbook-banner-slider') || null;
      if(lookbookBannerSliderEditor){
        lookbookBannerSlider();
      }
    });
  });
}

